import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withLoading } from "../../../../redux-modules/loading-overlay";
import { getCurrentUser } from "../../../../redux-modules/current-user";
import {
  SortProperty,
  genericObjectSort
} from "../../../../common/utils/object-sort";
import TopicsActions from "../../actions/customers/topics";
import { getTopics } from "../../selectors/customers/topics";
import ActionHandler from "../ActionHandler";
import SwitchList from '../SwitchList';
import Header from "../../../../common/components/Layout/Header";
import LoadingView from '../../../../common/components/LoadingView';
import { Card, CardText } from 'react-toolbox/lib/card';


class TopicsPage extends React.Component {
  static promises = {
    includePromises: [
      { type: "ENTITY/ENTITY_GET", meta: { namespace: "topics" } },
      { type: "ENTITY/ENTITY_PUT", meta: { namespace: "topics" } }
    ]
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: this.loadSelectedFromProps(props),
      save: {
        shouldSave: false,
        data: []
      },
      isFetchingTopics:
        !!props.currentUser.id && (!props.topics || !props.topics.length)
    };
  }

  fetchTopics = (...args) => {
    this.setState({ isFetchingTopics: true });
    return this.props.actions.topics
      .get(...args)
      .then(result => {
        this.setState({ isFetchingTopics: false });
        return result;
      })
      .catch(error => {
        this.setState({ isFetchingTopics: false });
        throw error;
      });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading) {
      return;
    }
    this.setState(prevState => {
      return {
        ...prevState,
        selected: this.loadSelectedFromProps(nextProps)
      };
    });
  }

  loadSelectedFromProps = props => {
    const { topics = [] } = props;
    return topics.reduce((acc, curr) => {
      if (curr.isSelected) {
        return [...acc, curr.key];
      }
      return acc;
    }, []);
  };

  handleTopicClick = key => () => {
    const { selected } = this.state;

    let updatedSelected;
    if (selected.indexOf(key) >= 0) {
      // topic is already selected, deslect it
      updatedSelected = selected.reduce((acc, curr) => {
        if (curr !== key) {
          return [...acc, curr];
        }
        return acc;
      }, []);
    } else {
      updatedSelected = [...selected, key];
    }

    if (updatedSelected) {
      this.setState(prevState => ({
        ...prevState,
        selected: updatedSelected
      }));
    }
  };

  handleSubmit = () => {
    const { selected } = this.state;
    const { topics } = this.props;
    const data = {
      items: topics.map(pref => {
        return {
          ...pref,
          isSelected: selected.indexOf(pref.key) >= 0
        };
      })
    };
    return this.updateSave({ shouldSave: true, data });
  };

  saveAction = data => {
    this.updateSave({ shouldSave: false });
    return this.props.actions.topics.put(data);
  };

  updateSave = ({ shouldSave, data = [] }) => {
    this.setState(prevState => ({
      ...prevState,
      save: {
        shouldSave,
        data
      }
    }));
  };

  renderActionHandlers = () => {
    const { isLoading, topics } = this.props;
    const { save } = this.state;
    return (
      <div>
        <ActionHandler
          condition={!!this.props.currentUser.id && (!topics || !topics.length)}
          action={this.fetchTopics}
        />
        <ActionHandler
          condition={save.shouldSave && !isLoading}
          action={this.saveAction}
          data={[save.data]}
        >
          {results => {
            if (
              results &&
              !results.hasError &&
              typeof this.props.goForward === "function"
            ) {
              this.props.goForward();
            }
            return null;
          }}
        </ActionHandler>
      </div>
    );
  };

  render() {
    const { topics, renderSubmit } = this.props;
    const { selected, isFetchingTopics } = this.state;

    if (isFetchingTopics) {
      return (
        <div>
          <Header />
          {this.renderActionHandlers()}
          <LoadingView />
        </div>
      );
    }

    if(topics.length == 0) return (<div>{this.renderActionHandlers()}</div>);

    var data = { 
      checked : {},
      items: topics.map((t)=> {
        return {key: t.key,
          description: t.displayText,
          isSelected: t.isSelected
        }
      })
  }

  for (var i in topics) {
    data.checked[topics[i].key] = selected.indexOf(topics[i].key) >= 0;
  }
  
    return (
      <div>
        <Header />
        {this.renderActionHandlers()}
        <Card>
          <CardText>
              <SwitchList
                    items={data.items}
                    selected={selected}
                    data={data.checked}
                    onChange={this.handleTopicClick}
                  >
              </SwitchList>
            </CardText>
        </Card>
        {renderSubmit(this.handleSubmit)}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  return {
    currentUser,
    topics: getTopics(state).sort(genericObjectSort(new SortProperty("order")))
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      topics: bindActionCreators(TopicsActions, dispatch)
    }
  };
};

export default withLoading(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TopicsPage)
);



// WEBPACK FOOTER //
// ./src/App/account/components/TopicsPage/index.js